import { AsyncPipe } from '@angular/common';
import { Component,  ChangeDetectionStrategy, output, inject } from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import { InvoiceDunningStatus, RecurringOccuranceType } from '@fitness-force/enum';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-timeline-actions',
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe],
  templateUrl: './payment-timeline-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTimelineActionsComponent {
  private readonly authService = inject(AuthSevices);
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc
  rowIndex: number = 0;

  currentLggedInUser: any;
  readonly onAction = output<{ action: string; columnData: any; rowIndex: number }>();

  constructor() { 
    this.currentLggedInUser = this.authService.currentUserDetails();
  }



  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
  }

  canShowRetry(columnData: any): boolean {
    const status = columnData?.status?.toLowerCase();
    const paymentStatus = columnData?.payment_status?.toLowerCase();
    const dunningStatus = columnData?.occurance_dunning_status;
    const totalPayment = columnData?.total_payment_in_minor_currency;
    const occurance = columnData?.occurance;
    const isRecurring = columnData?.is_recurring;
    return (status === "open" && totalPayment === 0 && isRecurring && (dunningStatus ===  InvoiceDunningStatus.Exhausted || dunningStatus?.toString() === InvoiceDunningStatus[InvoiceDunningStatus.Exhausted])) || (paymentStatus === "failed" && occurance !== 1 && (dunningStatus ===  InvoiceDunningStatus.Exhausted || dunningStatus?.toString() === InvoiceDunningStatus[InvoiceDunningStatus.Exhausted]));
  }

  canShowEditOccurrence(columnData: any): boolean {
    if (!columnData) {
      return false;
    }

    const occurrenceType = columnData.occurance_type;
    const isRecurringOccurrence =
      (occurrenceType === RecurringOccuranceType.Recurring ||
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.Recurring] ||
      occurrenceType === RecurringOccuranceType.MiddCycleDiscount ||
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.MiddCycleDiscount] || 
      occurrenceType == RecurringOccuranceType.EndProrata || 
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.EndProrata] ||
      occurrenceType == RecurringOccuranceType.Enhancement || 
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.Enhancement])
      && columnData.occurance_invoice_id ==  0;

    if (!isRecurringOccurrence) {
      return false;
    }

    const isBillingStopped =
      occurrenceType === RecurringOccuranceType.BillingStopped ||
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.BillingStopped];

    const isFreezeOccurrence =
      occurrenceType === RecurringOccuranceType.Freeze ||
      occurrenceType?.toString() === RecurringOccuranceType[RecurringOccuranceType.Freeze];

    if (isBillingStopped || isFreezeOccurrence) {
      return false;
    }

    // const paymentStatus = columnData.payment_status;
    // const isEditablePaymentStatus =
    //   paymentStatus === PaymentDerivedStatus.None ||
    //   paymentStatus?.toString() === PaymentDerivedStatus[PaymentDerivedStatus.None] ||
    //   paymentStatus === PaymentDerivedStatus.Created ||
    //   paymentStatus?.toString() === PaymentDerivedStatus[PaymentDerivedStatus.Created] ||
    //   paymentStatus === PaymentDerivedStatus.Initiated ||
    //   paymentStatus?.toString() === PaymentDerivedStatus[PaymentDerivedStatus.Initiated];

    return isRecurringOccurrence;
  }

  canShowActions(columnData: any, additionData: string[] | null | undefined): boolean {
    if (!columnData || !Array.isArray(additionData)) {
      return false;
    }

    const canRetry = additionData.includes('retrypayment') && this.canShowRetry(columnData);
    const canEdit =
      additionData.includes('editoccurrence') &&
      this.canShowEditOccurrence(columnData) &&
      this.canDoMidCycleDiscount;

    return canRetry || canEdit;
  }

  get canDoMidCycleDiscount(): boolean {
    return this.currentLggedInUser && (this.currentLggedInUser.role.toLowerCase() == 'admin' || this.currentLggedInUser.can_admin_billing == 'true')
  }

}

